import SnackbarNotification from '@/store/modules/snackbarNotification/constants';

export default {
  [SnackbarNotification.actionTypes.info]({ commit }, message) {
    commit(SnackbarNotification.mutationTypes.add, {
      timeout: 3000,
      type: 'info',
      message,
    });
  },

  [SnackbarNotification.actionTypes.error]({ commit }, message) {
    commit(SnackbarNotification.mutationTypes.add, {
      timeout: 3000,
      type: 'error',
      message,
    });
  },

  [SnackbarNotification.actionTypes.success]({ commit }, message) {
    commit(SnackbarNotification.mutationTypes.add, {
      timeout: 3000,
      type: 'success',
      message,
    });
  },

  [SnackbarNotification.actionTypes.remove]({ commit }, message) {
    commit(SnackbarNotification.mutationTypes.remove, message);
  },
};
